import { InsightCatalogue } from '../InsightCatalogue';
import {
  InsightMetric,
  BaseInsightPayload,
  validateInsightStructure,
  FullInsightPayload,
} from '../InsightDataPayload';

export interface TeamUtilizationPayload extends FullInsightPayload {
  data: {
    type: InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_TEAM_UTILIZATION;
    id: string;
    attributes: {
      data: Array<{
        team_id: string;
        team_name: string;
        task_utilization_percent: number;
        event_utilization_percent: number;
        target_utilization_percent: number;
      }>;
      aggregate: {
        average_utilization_percent: InsightMetric;
        target_utilization_percent: InsightMetric;
      };
    };
  };
}

type TeamUtilizationData = {
  data: Array<{
    team_id: string;
    team_name: string;
    utilization_breakdown: {
      task: {
        actual_hours_in_range: number;
        utilization_percent: number;
      };
      event: {
        scheduled_hours_in_range: number;
        utilization_percent: number;
      };
    };
    overall_utilization_percent: number;
  }>;
  aggregate: {
    average_utilization_percent: InsightMetric;
    target_utilization_percent: InsightMetric;
  };
};

export const parseTeamUtilizationPayload = (
  payload: BaseInsightPayload
): TeamUtilizationPayload => {
  const { data, relationships, links } = payload;

  validateInsightStructure(
    data.type,
    InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_TEAM_UTILIZATION,
    data.attributes,
    true,
    true,
    ['average_utilization_percent', 'target_utilization_percent']
  );

  // Type assertion after validation
  const typedAttributes = data.attributes as TeamUtilizationData;

  return {
    data: {
      type: InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_TEAM_UTILIZATION,
      id: data.id,
      attributes: {
        data: typedAttributes.data.map((item) => ({
          team_id: item.team_id,
          team_name: item.team_name,
          task_utilization_percent:
            item.utilization_breakdown.task.utilization_percent,
          event_utilization_percent:
            item.utilization_breakdown.event.utilization_percent,
          overall_utilization_percent: item.overall_utilization_percent,
          target_utilization_percent:
            typedAttributes.aggregate.target_utilization_percent.current || 80,
        })),
        aggregate: {
          average_utilization_percent:
            typedAttributes.aggregate.average_utilization_percent,
          target_utilization_percent:
            typedAttributes.aggregate.target_utilization_percent,
        },
      },
    },
    ...(relationships && { relationships }),
    links,
  };
};
